'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useMemo, Activity } from 'react';
import { Table, TableHeader, TableColumn, TableBody, TableRow, TableCell, Card, CardBody, CardHeader, Button, Chip, Dropdown, DropdownTrigger, DropdownMenu, DropdownItem, useDisclosure, Spinner, Alert, Divider, cn } from '@heroui/react';
import { Icon } from '@iconify/react';
import { motion } from 'motion/react';
import { ChainType } from '@/constants/chain-specific';
import type { LiquidityPosition } from '@/hooks/liquidity/useLiquidityPositions';
import { formatNumber } from '@/util/balance/formatNumber';
import { SendLPModal } from './SendLPModal';
import { DEX_LIST } from '@/constants/project-specific/farms/dex';
import { TokenLogo } from '@/components/Tokens/TokenLogo';
import { useIsMobile } from '@/hooks/utility/useIsMobile';
import type { Address } from 'viem';
interface PositionsListProps {
  positions: LiquidityPosition[];
  isLoading: boolean;
  error: Error | null;
  onRefresh: () => void;
  chainId?: ChainType;
  className?: string;
  tokenData?: Record<Address, any>; // For passing to increase modal
  // Overview stats
  totalValueUsd?: number;
  totalFeesUsd?: number;
  // Navigation callbacks
  onNavigateToAdd?: (position?: LiquidityPosition) => void;
  onNavigateToRemove?: (position: LiquidityPosition) => void;
}
type SortKey = 'value' | 'fees' | 'apr' | 'created' | 'pool';
type FilterType = 'all' | 'active' | 'inactive' | 'v2' | 'v3';
export function PositionsList(t0) {
  const $ = _c(161);
  const {
    positions,
    isLoading,
    error,
    onRefresh,
    chainId,
    className,
    tokenData,
    totalValueUsd: t1,
    totalFeesUsd: t2,
    onNavigateToAdd,
    onNavigateToRemove
  } = t0;
  const totalValueUsd = t1 === undefined ? 0 : t1;
  const totalFeesUsd = t2 === undefined ? 0 : t2;
  const [sortKey, setSortKey] = useState("value");
  const [sortDirection, setSortDirection] = useState("desc");
  const [filter, setFilter] = useState("all");
  const [selectedPositionId, setSelectedPositionId] = useState(null);
  const [sendPosition, setSendPosition] = useState(null);
  const {
    isOpen: isSendModalOpen,
    onOpen: onSendModalOpen,
    onOpenChange: onSendModalOpenChange
  } = useDisclosure();
  const isMobile = useIsMobile();
  let t3;
  if ($[0] !== positions) {
    const seen = new Set();
    t3 = positions.filter(position => {
      const uniqueKey = `${position.contractAddress}-${position.token0.address}-${position.token1.address}-${position.id}`;
      if (seen.has(uniqueKey)) {
        return false;
      }
      seen.add(uniqueKey);
      return true;
    });
    $[0] = positions;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const uniquePositions = t3;
  const t4 = uniquePositions.length;
  let t5;
  if ($[2] !== uniquePositions) {
    t5 = uniquePositions.filter(_temp);
    $[2] = uniquePositions;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== uniquePositions) {
    t6 = uniquePositions.length > 0 ? uniquePositions.reduce(_temp2, 0) / uniquePositions.length : 0;
    $[4] = uniquePositions;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t5.length || $[7] !== t6 || $[8] !== totalFeesUsd || $[9] !== totalValueUsd || $[10] !== uniquePositions.length) {
    t7 = {
      totalPositions: t4,
      activePositions: t5.length,
      totalValue: totalValueUsd,
      totalFees: totalFeesUsd,
      avgApr: t6
    };
    $[6] = t5.length;
    $[7] = t6;
    $[8] = totalFeesUsd;
    $[9] = totalValueUsd;
    $[10] = uniquePositions.length;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const stats = t7;
  let t8;
  if ($[12] !== selectedPositionId) {
    t8 = position_0 => {
      const positionId = `${position_0.contractAddress}-${position_0.token0.address}-${position_0.token1.address}-${position_0.id}`;
      setSelectedPositionId(selectedPositionId === positionId ? null : positionId);
    };
    $[12] = selectedPositionId;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const handleRowClick = t8;
  let t9;
  if ($[14] !== onNavigateToRemove) {
    t9 = position_1 => {
      if (onNavigateToRemove) {
        onNavigateToRemove(position_1);
      }
    };
    $[14] = onNavigateToRemove;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const handleRemoveClick = t9;
  let t10;
  if ($[16] !== onNavigateToAdd) {
    t10 = position_2 => {
      if (onNavigateToAdd) {
        onNavigateToAdd(position_2);
      }
    };
    $[16] = onNavigateToAdd;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const handleIncreaseClick = t10;
  let t11;
  if ($[18] !== onSendModalOpen) {
    t11 = position_3 => {
      setSendPosition(position_3);
      onSendModalOpen();
    };
    $[18] = onSendModalOpen;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const handleSendClick = t11;
  let filtered;
  if ($[20] !== filter || $[21] !== sortDirection || $[22] !== sortKey || $[23] !== uniquePositions) {
    filtered = [...uniquePositions];
    bb0: switch (filter) {
      case "active":
        {
          filtered = filtered.filter(_temp3);
          break bb0;
        }
      case "inactive":
        {
          filtered = filtered.filter(_temp4);
          break bb0;
        }
      case "v2":
        {
          filtered = filtered.filter(_temp5);
          break bb0;
        }
      case "v3":
        {
          filtered = filtered.filter(_temp6);
        }
    }
    let t12;
    if ($[25] !== sortDirection || $[26] !== sortKey) {
      t12 = (a, b) => {
        let aValue;
        let bValue;
        bb69: switch (sortKey) {
          case "value":
            {
              aValue = a.totalValueUsd;
              bValue = b.totalValueUsd;
              break bb69;
            }
          case "fees":
            {
              aValue = a.feesValueUsd;
              bValue = b.feesValueUsd;
              break bb69;
            }
          case "apr":
            {
              aValue = a.apr;
              bValue = b.apr;
              break bb69;
            }
          default:
            {
              aValue = 0;
              bValue = 0;
            }
        }
        return sortDirection === "desc" ? bValue - aValue : aValue - bValue;
      };
      $[25] = sortDirection;
      $[26] = sortKey;
      $[27] = t12;
    } else {
      t12 = $[27];
    }
    filtered.sort(t12);
    $[20] = filter;
    $[21] = sortDirection;
    $[22] = sortKey;
    $[23] = uniquePositions;
    $[24] = filtered;
  } else {
    filtered = $[24];
  }
  const filteredAndSortedPositions = filtered;
  let t12;
  if ($[28] !== sortDirection || $[29] !== sortKey) {
    t12 = key => {
      if (sortKey === key) {
        setSortDirection(sortDirection === "desc" ? "asc" : "desc");
      } else {
        setSortKey(key);
        setSortDirection("desc");
      }
    };
    $[28] = sortDirection;
    $[29] = sortKey;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  const handleSort = t12;
  const getStatusColor = _temp7;
  const getStatusText = _temp8;
  if (error) {
    let t13;
    if ($[31] !== onRefresh) {
      t13 = <Button size="sm" variant="flat" onPress={onRefresh}>Retry</Button>;
      $[31] = onRefresh;
      $[32] = t13;
    } else {
      t13 = $[32];
    }
    let t14;
    if ($[33] !== error.message || $[34] !== t13) {
      t14 = <Alert color="danger" variant="flat" title="Error Loading Positions" description={error.message} endContent={t13} />;
      $[33] = error.message;
      $[34] = t13;
      $[35] = t14;
    } else {
      t14 = $[35];
    }
    return t14;
  }
  if (isLoading) {
    let t13;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <CardBody className="flex items-center justify-center py-12"><Spinner size="lg" /><p className="mt-4 text-default-500">Loading positions...</p></CardBody>;
      $[36] = t13;
    } else {
      t13 = $[36];
    }
    let t14;
    if ($[37] !== className) {
      t14 = <Card className={className}>{t13}</Card>;
      $[37] = className;
      $[38] = t14;
    } else {
      t14 = $[38];
    }
    return t14;
  }
  if (uniquePositions.length === 0) {
    let t13;
    if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <CardBody className="text-center py-12"><Icon icon="mdi:liquidity" className="text-6xl text-default-300 mx-auto mb-4" /><h3 className="text-xl font-semibold mb-2">No Liquidity Positions</h3><p className="text-default-500 mb-6">You haven't provided liquidity to any pools yet. Start by adding liquidity to earn fees.</p></CardBody>;
      $[39] = t13;
    } else {
      t13 = $[39];
    }
    let t14;
    if ($[40] !== className) {
      t14 = <Card className={className}>{t13}</Card>;
      $[40] = className;
      $[41] = t14;
    } else {
      t14 = $[41];
    }
    return t14;
  }
  const t13 = `${className}`;
  let t14;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <h2 className="text-xl font-semibold">Overview</h2>;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  let t15;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Icon icon="mdi:refresh" width="20px" />;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  let t16;
  if ($[44] !== isLoading || $[45] !== onRefresh) {
    t16 = <CardHeader><div className="flex items-center justify-between w-full">{t14}<Button variant="light" size="lg" isIconOnly={true} onPress={onRefresh} isLoading={isLoading} className="">{t15}</Button></div></CardHeader>;
    $[44] = isLoading;
    $[45] = onRefresh;
    $[46] = t16;
  } else {
    t16 = $[46];
  }
  const t17 = isMobile ? "hidden" : "visible";
  let t18;
  if ($[47] !== stats.activePositions) {
    t18 = <span className="text-secondary text-2xl">{stats.activePositions}</span>;
    $[47] = stats.activePositions;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  let t19;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <span className="text-lg align-middle"> / </span>;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] !== stats.totalPositions) {
    t20 = <span className="text-2xl">{stats.totalPositions}</span>;
    $[50] = stats.totalPositions;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  let t21;
  if ($[52] !== t18 || $[53] !== t20) {
    t21 = <div className="text-2xl align-middle">{t18}{t19}{t20}</div>;
    $[52] = t18;
    $[53] = t20;
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  let t22;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <div className="text-sm text-default-500">Total Active LPs</div>;
    $[55] = t22;
  } else {
    t22 = $[55];
  }
  let t23;
  if ($[56] !== t21) {
    t23 = <div className="text-center">{t21}{t22}</div>;
    $[56] = t21;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  let t24;
  if ($[58] !== t17 || $[59] !== t23) {
    t24 = <Activity mode={t17}>{t23}</Activity>;
    $[58] = t17;
    $[59] = t23;
    $[60] = t24;
  } else {
    t24 = $[60];
  }
  let t25;
  if ($[61] !== stats.totalValue) {
    t25 = formatNumber(stats.totalValue, 2);
    $[61] = stats.totalValue;
    $[62] = t25;
  } else {
    t25 = $[62];
  }
  let t26;
  if ($[63] !== t25) {
    t26 = <div className="text-2xl font-bold">${t25}</div>;
    $[63] = t25;
    $[64] = t26;
  } else {
    t26 = $[64];
  }
  let t27;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <div className="text-sm text-default-500">Total Value</div>;
    $[65] = t27;
  } else {
    t27 = $[65];
  }
  let t28;
  if ($[66] !== t26) {
    t28 = <div className="text-center">{t26}{t27}</div>;
    $[66] = t26;
    $[67] = t28;
  } else {
    t28 = $[67];
  }
  let t29;
  if ($[68] !== stats.avgApr) {
    t29 = stats.avgApr.toFixed(1);
    $[68] = stats.avgApr;
    $[69] = t29;
  } else {
    t29 = $[69];
  }
  let t30;
  if ($[70] !== t29) {
    t30 = <div className="text-2xl font-bold text-warning">{t29}%</div>;
    $[70] = t29;
    $[71] = t30;
  } else {
    t30 = $[71];
  }
  let t31;
  if ($[72] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <div className="text-sm text-default-500">Avg APR</div>;
    $[72] = t31;
  } else {
    t31 = $[72];
  }
  let t32;
  if ($[73] !== t30) {
    t32 = <div className="text-center">{t30}{t31}</div>;
    $[73] = t30;
    $[74] = t32;
  } else {
    t32 = $[74];
  }
  let t33;
  if ($[75] !== t24 || $[76] !== t28 || $[77] !== t32) {
    t33 = <div className="grid grid-cols-2 md:grid-cols-3 gap-4">{t24}{t28}{t32}</div>;
    $[75] = t24;
    $[76] = t28;
    $[77] = t32;
    $[78] = t33;
  } else {
    t33 = $[78];
  }
  let t34;
  if ($[79] !== stats.totalFees) {
    t34 = stats.totalFees > 0 && <><Divider className="my-4" /><div className="flex items-center justify-between"><span className="text-sm text-default-500">Unclaimed Fees</span><div className="flex items-center gap-2"><span className="font-semibold text-success">${formatNumber(stats.totalFees, 2)}</span><Button size="sm" color="success" variant="flat">Claim All</Button></div></div></>;
    $[79] = stats.totalFees;
    $[80] = t34;
  } else {
    t34 = $[80];
  }
  let t35;
  if ($[81] !== t33 || $[82] !== t34) {
    t35 = <CardBody>{t33}{t34}</CardBody>;
    $[81] = t33;
    $[82] = t34;
    $[83] = t35;
  } else {
    t35 = $[83];
  }
  let t36;
  if ($[84] !== t16 || $[85] !== t35) {
    t36 = <Card>{t16}{t35}</Card>;
    $[84] = t16;
    $[85] = t35;
    $[86] = t36;
  } else {
    t36 = $[86];
  }
  let t37;
  if ($[87] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <Icon icon="mdi:chevron-down" />;
    $[87] = t37;
  } else {
    t37 = $[87];
  }
  let t38;
  if ($[88] !== filter) {
    t38 = filter === "all" ? "All Positions" : filter === "active" ? "Active" : filter === "inactive" ? "Inactive" : filter.toUpperCase();
    $[88] = filter;
    $[89] = t38;
  } else {
    t38 = $[89];
  }
  let t39;
  if ($[90] !== t38) {
    t39 = <DropdownTrigger><Button variant="flat" size="sm" endContent={t37}>{t38}</Button></DropdownTrigger>;
    $[90] = t38;
    $[91] = t39;
  } else {
    t39 = $[91];
  }
  let t40;
  if ($[92] !== filter) {
    t40 = [filter];
    $[92] = filter;
    $[93] = t40;
  } else {
    t40 = $[93];
  }
  let t41;
  let t42;
  let t43;
  let t44;
  let t45;
  let t46;
  if ($[94] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = keys => setFilter(Array.from(keys)[0] as FilterType);
    t42 = <DropdownItem key="all">All Positions</DropdownItem>;
    t43 = <DropdownItem key="active">Active</DropdownItem>;
    t44 = <DropdownItem key="inactive">Inactive</DropdownItem>;
    t45 = <DropdownItem key="v2">V2 Only</DropdownItem>;
    t46 = <DropdownItem key="v3">V3 Only</DropdownItem>;
    $[94] = t41;
    $[95] = t42;
    $[96] = t43;
    $[97] = t44;
    $[98] = t45;
    $[99] = t46;
  } else {
    t41 = $[94];
    t42 = $[95];
    t43 = $[96];
    t44 = $[97];
    t45 = $[98];
    t46 = $[99];
  }
  let t47;
  if ($[100] !== t40) {
    t47 = <DropdownMenu selectedKeys={t40} onSelectionChange={t41}>{t42}{t43}{t44}{t45}{t46}</DropdownMenu>;
    $[100] = t40;
    $[101] = t47;
  } else {
    t47 = $[101];
  }
  let t48;
  if ($[102] !== t39 || $[103] !== t47) {
    t48 = <Dropdown>{t39}{t47}</Dropdown>;
    $[102] = t39;
    $[103] = t47;
    $[104] = t48;
  } else {
    t48 = $[104];
  }
  let t49;
  if ($[105] === Symbol.for("react.memo_cache_sentinel")) {
    t49 = <Icon icon="mdi:refresh" />;
    $[105] = t49;
  } else {
    t49 = $[105];
  }
  let t50;
  if ($[106] !== onRefresh) {
    t50 = <Button variant="light" size="sm" isIconOnly={true} onPress={onRefresh}>{t49}</Button>;
    $[106] = onRefresh;
    $[107] = t50;
  } else {
    t50 = $[107];
  }
  let t51;
  if ($[108] !== t48 || $[109] !== t50) {
    t51 = <div className="flex items-center gap-2">{t48}{t50}</div>;
    $[108] = t48;
    $[109] = t50;
    $[110] = t51;
  } else {
    t51 = $[110];
  }
  const t52 = filteredAndSortedPositions.length !== 1 ? "s" : "";
  let t53;
  if ($[111] !== filteredAndSortedPositions.length || $[112] !== t52) {
    t53 = <div className="text-sm text-default-500">{filteredAndSortedPositions.length} position{t52}</div>;
    $[111] = filteredAndSortedPositions.length;
    $[112] = t52;
    $[113] = t53;
  } else {
    t53 = $[113];
  }
  let t54;
  if ($[114] !== t51 || $[115] !== t53) {
    t54 = <div className="flex items-center justify-between flex-wrap gap-3">{t51}{t53}</div>;
    $[114] = t51;
    $[115] = t53;
    $[116] = t54;
  } else {
    t54 = $[116];
  }
  let t55;
  if ($[117] === Symbol.for("react.memo_cache_sentinel")) {
    t55 = {
      wrapper: "min-h-[400px] p-0"
    };
    $[117] = t55;
  } else {
    t55 = $[117];
  }
  let t56;
  if ($[118] !== handleSort) {
    t56 = <TableColumn onClick={() => handleSort("pool")} className="cursor-pointer">Pool</TableColumn>;
    $[118] = handleSort;
    $[119] = t56;
  } else {
    t56 = $[119];
  }
  let t57;
  if ($[120] !== handleSort) {
    t57 = <TableColumn allowsSorting={true} className="cursor-pointer" onClick={() => handleSort("value")}>Value</TableColumn>;
    $[120] = handleSort;
    $[121] = t57;
  } else {
    t57 = $[121];
  }
  const t58 = `cursor-pointer ${isMobile ? "hidden" : ""}`;
  let t59;
  if ($[122] !== handleSort) {
    t59 = () => handleSort("fees");
    $[122] = handleSort;
    $[123] = t59;
  } else {
    t59 = $[123];
  }
  let t60;
  if ($[124] !== t58 || $[125] !== t59) {
    t60 = <TableColumn allowsSorting={true} className={t58} onClick={t59}>Fees</TableColumn>;
    $[124] = t58;
    $[125] = t59;
    $[126] = t60;
  } else {
    t60 = $[126];
  }
  const t61 = `cursor-pointer ${isMobile ? "hidden" : ""}`;
  let t62;
  if ($[127] !== handleSort) {
    t62 = () => handleSort("apr");
    $[127] = handleSort;
    $[128] = t62;
  } else {
    t62 = $[128];
  }
  let t63;
  if ($[129] !== t61 || $[130] !== t62) {
    t63 = <TableColumn allowsSorting={true} className={t61} onClick={t62}>APR</TableColumn>;
    $[129] = t61;
    $[130] = t62;
    $[131] = t63;
  } else {
    t63 = $[131];
  }
  let t64;
  if ($[132] !== t56 || $[133] !== t57 || $[134] !== t60 || $[135] !== t63) {
    t64 = <TableHeader>{t56}{t57}{t60}{t63}</TableHeader>;
    $[132] = t56;
    $[133] = t57;
    $[134] = t60;
    $[135] = t63;
    $[136] = t64;
  } else {
    t64 = $[136];
  }
  let t65;
  if ($[137] !== chainId || $[138] !== filteredAndSortedPositions || $[139] !== handleIncreaseClick || $[140] !== handleRemoveClick || $[141] !== handleRowClick || $[142] !== handleSendClick || $[143] !== isMobile || $[144] !== selectedPositionId) {
    t65 = <TableBody>{filteredAndSortedPositions.map(position_7 => {
        const positionId_0 = `${position_7.contractAddress}-${position_7.token0.address}-${position_7.token1.address}-${position_7.id}`;
        const isSelected = selectedPositionId === positionId_0;
        return <><TableRow key={positionId_0} className={cn("cursor-pointer transition-all duration-200 hover:bg-default-50", isSelected && "bg-primary-50 dark:bg-primary-900/20")} onClick={() => handleRowClick(position_7)}><TableCell><div className="space-y-3"><div className="flex items-center gap-3"><div className="flex items-center -space-x-2"><TokenLogo chainId={chainId} tokenAddress={position_7.token0.address as Address} size="sm" className="border-2 border-background" fallbackText={position_7.token0.symbol?.charAt(0)} /><TokenLogo chainId={chainId} tokenAddress={position_7.token1.address as Address} size="sm" className="border-2 border-background" fallbackText={position_7.token1.symbol?.charAt(0)} /></div><div><div className="font-medium">{position_7.token0.symbol}/{position_7.token1.symbol}</div><div className="text-xs text-default-500 flex items-center gap-1"><img src={DEX_LIST[position_7.dex].logo} alt={position_7.dexName} className="w-3 h-3" />{position_7.dexName}<Chip size="sm" color={getStatusColor(position_7)} variant="flat">{getStatusText(position_7)}</Chip></div></div><div className="ml-auto"><motion.div animate={{
                      rotate: isSelected ? 180 : 0
                    }} transition={{
                      duration: 0.2,
                      ease: "easeInOut"
                    }}><Icon icon="mdi:chevron-down" className="text-lg" /></motion.div></div></div></div></TableCell><TableCell><div><div className="font-medium">${formatNumber(position_7.totalValueUsd, 2)}</div>{!isMobile && <div className="text-xs text-default-500">{formatNumber(parseFloat(position_7.token0AmountFormatted), 4)} {position_7.token0.symbol} + {formatNumber(parseFloat(position_7.token1AmountFormatted), 4)} {position_7.token1.symbol}</div>}</div></TableCell><TableCell className={isMobile ? "hidden" : ""}><div><div className="font-medium text-success">${formatNumber(position_7.feesValueUsd, 2)}</div>{!isMobile && <div className={cn("text-xs text-default-500")}>{formatNumber(parseFloat(position_7.fees0Formatted), 6)} {position_7.token0.symbol} + {formatNumber(parseFloat(position_7.fees1Formatted), 6)} {position_7.token1.symbol}</div>}</div></TableCell><TableCell className={isMobile ? "hidden" : ""}><span className="font-medium">{position_7.apr.toFixed(2)}%</span></TableCell></TableRow>{isSelected && <TableRow key={`${positionId_0}-expanded`}><TableCell colSpan={4} className="p-0"><motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} transition={{
                duration: 0.3,
                ease: "easeInOut",
                opacity: {
                  duration: 0.2
                }
              }} style={{
                willChange: "height, opacity",
                overflow: "hidden"
              }}><motion.div initial={{
                  y: -10,
                  opacity: 0
                }} animate={{
                  y: 0,
                  opacity: 1
                }} transition={{
                  duration: 0.2,
                  delay: 0.1
                }} className={cn("px-4 py-3 bg-default-25 dark:bg-default-100/20 border border-divider rounded-lg", "mx-2 mb-2")}>{isMobile && <div className="flex flex-col w-full mb-4"><div><div className="flex flex-col text-md justify-center items-center"><div className="flex flex-col text-md justify-center items-center">{formatNumber(parseFloat(position_7.token0AmountFormatted), 4)} {position_7.token0.symbol}</div><div className="flex flex-col text-md justify-center items-center">+</div><div className="flex flex-col text-md justify-center items-center">{formatNumber(parseFloat(position_7.token1AmountFormatted), 4)} {position_7.token1.symbol}</div></div></div>{position_7.feesValueUsd > 0 && <div><div className="text-xs text-default-500 mb-1">Unclaimed Fees</div><div className="text-sm"><div className="font-medium text-success">${formatNumber(position_7.feesValueUsd, 2)}</div><div className="text-xs text-default-500">{formatNumber(parseFloat(position_7.fees0Formatted), 6)} {position_7.token0.symbol}</div><div className="text-xs text-default-500">{formatNumber(parseFloat(position_7.fees1Formatted), 6)} {position_7.token1.symbol}</div></div></div>}</div>}<motion.div className={cn("w-full gap-3", isMobile ? "flex flex-col items-stretch" : "flex flex-wrap justify-center items-center")} initial={{
                    opacity: 0,
                    y: 10
                  }} animate={{
                    opacity: 1,
                    y: 0
                  }} transition={{
                    duration: 0.3,
                    delay: 0.2
                  }}><motion.div initial={{
                      opacity: 0,
                      scale: 0.8
                    }} animate={{
                      opacity: 1,
                      scale: 1
                    }} transition={{
                      duration: 0.2,
                      delay: 0.3
                    }} className={isMobile ? "w-full" : ""}><Button size="sm" color="primary" startContent={<Icon icon="mdi:plus" />} onPress={() => handleIncreaseClick(position_7)} className={isMobile ? "w-full" : ""}>Add Liquidity</Button></motion.div><motion.div initial={{
                      opacity: 0,
                      scale: 0.8
                    }} animate={{
                      opacity: 1,
                      scale: 1
                    }} transition={{
                      duration: 0.2,
                      delay: 0.35
                    }} className={isMobile ? "w-full" : ""}><Button size="sm" color="danger" variant="flat" startContent={<Icon icon="mdi:minus" />} onPress={() => handleRemoveClick(position_7)} className={isMobile ? "w-full" : ""}>Remove Liquidity</Button></motion.div><motion.div initial={{
                      opacity: 0,
                      scale: 0.8
                    }} animate={{
                      opacity: 1,
                      scale: 1
                    }} transition={{
                      duration: 0.2,
                      delay: 0.4
                    }} className={isMobile ? "w-full" : ""}><Button size="sm" color="secondary" variant="flat" startContent={<Icon icon="mdi:send" />} onPress={() => handleSendClick(position_7)} className={isMobile ? "w-full" : ""}>Send</Button></motion.div>{position_7.feesValueUsd > 0 && <motion.div initial={{
                      opacity: 0,
                      scale: 0.8
                    }} animate={{
                      opacity: 1,
                      scale: 1
                    }} transition={{
                      duration: 0.2,
                      delay: 0.45
                    }} className={isMobile ? "w-full" : ""}><Button size="sm" color="success" variant="flat" startContent={<Icon icon="mdi:currency-usd" />} className={isMobile ? "w-full" : ""}>Claim ${formatNumber(position_7.feesValueUsd, 2)}</Button></motion.div>}</motion.div></motion.div></motion.div></TableCell></TableRow>}</>;
      })}</TableBody>;
    $[137] = chainId;
    $[138] = filteredAndSortedPositions;
    $[139] = handleIncreaseClick;
    $[140] = handleRemoveClick;
    $[141] = handleRowClick;
    $[142] = handleSendClick;
    $[143] = isMobile;
    $[144] = selectedPositionId;
    $[145] = t65;
  } else {
    t65 = $[145];
  }
  let t66;
  if ($[146] !== t64 || $[147] !== t65) {
    t66 = <Table aria-label="Liquidity positions" classNames={t55}>{t64}{t65}</Table>;
    $[146] = t64;
    $[147] = t65;
    $[148] = t66;
  } else {
    t66 = $[148];
  }
  let t67;
  if ($[149] !== chainId || $[150] !== isSendModalOpen || $[151] !== onSendModalOpenChange || $[152] !== sendPosition || $[153] !== tokenData) {
    t67 = sendPosition && <SendLPModal position={sendPosition} isOpen={isSendModalOpen} onClose={() => onSendModalOpenChange()} onOpenChange={onSendModalOpenChange} chainId={chainId} tokenData={tokenData} />;
    $[149] = chainId;
    $[150] = isSendModalOpen;
    $[151] = onSendModalOpenChange;
    $[152] = sendPosition;
    $[153] = tokenData;
    $[154] = t67;
  } else {
    t67 = $[154];
  }
  let t68;
  if ($[155] !== t13 || $[156] !== t36 || $[157] !== t54 || $[158] !== t66 || $[159] !== t67) {
    t68 = <div className={t13}>{t36}{t54}{t66}{t67}</div>;
    $[155] = t13;
    $[156] = t36;
    $[157] = t54;
    $[158] = t66;
    $[159] = t67;
    $[160] = t68;
  } else {
    t68 = $[160];
  }
  return t68;
}
function _temp8(position_5) {
  if (position_5.version === "v2") {
    return "V2";
  }
  if (position_5.range?.inRange) {
    return "Active";
  }
  return "Inactive";
}
function _temp7(position_4) {
  if (position_4.version === "v2") {
    return "primary";
  }
  if (position_4.range?.inRange) {
    return "success";
  }
  return "warning";
}
function _temp6(p_1) {
  return p_1.version === "v3";
}
function _temp5(p_2) {
  return p_2.version === "v2";
}
function _temp4(p_3) {
  return !p_3.range?.inRange;
}
function _temp3(p_4) {
  return p_4.range?.inRange;
}
function _temp2(sum, p_0) {
  return sum + p_0.apr;
}
function _temp(p) {
  return p.range?.inRange;
}